import { API_CALL } from 'actions/actionConstants'
import { AnyAppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACCOUNT } from 'actions/apiActionConstants'
import requestLoyaltyAccount from 'api/loyalty/requestLoyaltyAccount'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

function fetchLoyaltyAccount(token?: string): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const loyaltyAccount = state.loyalty.account

    if (
      !getIsLoyaltyEnabled(state) ||
      hasLoyaltyAccount ||
      loyaltyAccount.fetching ||
      loyaltyAccount.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT,
      request: () => requestLoyaltyAccount(token),
    })
  }
}

export default fetchLoyaltyAccount
